export default {
  ADD_RECIPE(state, recipe) {
    state.recipes.unshift(recipe);
    state.totalDataRow++;
  },
  COPY_RECIPE(state,recipe){
    state.recipes.unshift(recipe);
    state.totalDataRow++;
  },
  SET_RECIPE(state, res) {
    state.recipes = res.items
    state.totalDataRow = res.totalCount;
  },
  UPDATE_RECIPE(state, recipe) {
    const recipeIndex = state.recipes.findIndex((p) => p.id == recipe.id)
    Object.assign(state.recipes[recipeIndex], recipe)
  },
  REMOVE_RECIPE(state, recipeId) {
    const recipeIndex = state.recipes.findIndex((p) => p.id == recipeId)
    state.recipes.splice(recipeIndex, 1)
  },
}
